import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { translate } from 'react-i18next';
import { compose, withProps, withState, withHandlers } from 'recompose';
import { withScriptjs, withGoogleMap, GoogleMap, Marker, InfoWindow } from 'react-google-maps';
import { GOOGLE_MAP_URL } from '../../constants/';
import { List } from 'immutable';
import markerImage from '../../assets/images/map-marker.svg';
import {blackWhiteStyle} from './blackWhiteStyle';


const Map = compose(
  withProps({
    googleMapURL: GOOGLE_MAP_URL,
  }),
  withState('zoom', 'onZoomChange', (props) => props.zoom || 10),
  withHandlers(() => {
    const refs = {
      map: undefined,
    };

    return {
      onMapMounted: () => ref => {
        refs.map = ref;
        if (refs.map) {
          const bounds = new window.google.maps.LatLngBounds();
          const children = refs.map.props.children;
          children.forEach((child) => {
            if (child.type === Marker) {
              bounds.extend(new window.google.maps.LatLng(child.props.position.lat, child.props.position.lng));
            }
          });
          if (children.size === 1) {
            refs.map.panToBounds(bounds);
          } else {
            refs.map.fitBounds(bounds);
          }
        }
      },
      onZoomChanged: ({ onZoomChange }) => () => {
        onZoomChange(refs.map.getZoom())
      },
      onClick: () => (id, props) => {
        props.selectRestaurant(id);
      },
      showInfo: () => (value, props) => {
        props.displayInfo(value);
      },
      onToggleOpen: () => (props) => {
        props.closeInfo();
      }
    }
  }),
  withScriptjs,
  withGoogleMap
)(props =>
  <GoogleMap
    center={props.center}
    zoom={props.zoom}
    ref={props.onMapMounted}
    onZoomChanged={props.onZoomChanged}
    defaultOptions={{ styles: props.blackWhite ? blackWhiteStyle : [] }}
  >
    {props.markers.valueSeq().map(marker => (
      <Marker
        icon={{
          url: markerImage,
          scaledSize: {width: 30, height: 40}
        }}
        position={{
          lat: parseFloat(marker.coordinate.coordinates[1]),
          lng: parseFloat(marker.coordinate.coordinates[0])
        }}
        onClick={()=>{props.showInfo(marker.id, props)}}
        key={marker.id}
      >
        {props.showInfoIndex === marker.id && props.isOpen &&
          <InfoWindow onCloseClick={() => props.onToggleOpen(props)}>
            <div className="map-marker">
              <p className="map-marker__name">{marker.name}</p>
              <p className="map-marker__phone">{marker.phone}</p>
              <p className="map-marker__address">{marker.address}</p>
              {marker.address_2 && <p className="map-marker__address">{marker.address_2}</p>}
              {marker.now_is_unavailable ?
                <p><strong>{props.t('unavailable')}</strong></p>
                :
                (marker.now_is_closed ?
                  <p><strong>{props.t('is_closed')}</strong></p>
                  :
                  (!props.hideTakeAway ?
                      <button onClick={() => props.onClick(marker.id, props)}>
                        {props.t('takeAway')}
                      </button>
                      : null
                  )
                )
              }
            </div>
          </InfoWindow>
        }
      </Marker>
    ))}
  </GoogleMap>
);


class MapViewComponent extends Component {

  render() {
    const { t, restaurants, selectRestaurant, history, isOpen, showInfoIndex, hideTakeAway,
      zoom, blackWhite, displayInfo, closeInfo } = this.props;
    let markers = List();
    if (restaurants.size) {
      markers = restaurants.filter((value, key) => {
        return value.coordinate;
      });
    }

    let center = { lat: 49.826053, lng: 6.128832 };
    if (markers.size === 1) {
      const marker = markers.first();
      center.lat =  marker.coordinate.coordinates[1];
      center.lng =  marker.coordinate.coordinates[0];
    }
    return (
      <div className="map">
        {/*Map banner. Possibly not needed */}
        {/*<div className="map__banner">*/}
          {/*<div className="map__banner-content">*/}
            {/*CHOISISSEZ VOTRE*/}
            {/*PIZZA HUT RESTAURANT PRÉFÉRÉ*/}
            {/*POUR RELAXER AVEC TOUTE LA FAMILLE*/}
          {/*</div>*/}
        {/*</div>*/}
        <div id="map" className="map__container">
          <Map
            center={center}
            markers={markers}
            selectRestaurant={selectRestaurant}
            isOpen={isOpen}
            showInfoIndex={showInfoIndex}
            history={history}
            hideTakeAway={hideTakeAway}
            zoom={zoom}
            t={t}
            loadingElement={<div style={{ height: `100%` }} />}
            containerElement={<div style={{ height: `100%` }} />}
            mapElement={<div style={{ height: `100%` }} />}
            blackWhite={blackWhite}
            displayInfo={displayInfo}
            closeInfo={closeInfo}
          />
        </div>
      </div>
    );
  }
}

MapViewComponent.propTypes = {
  restaurants: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  selectRestaurant: PropTypes.func,
  displayInfo: PropTypes.func,
  closeInfo: PropTypes.func,
  zoom: PropTypes.number,
  blackWhite: PropTypes.bool
};


export default withRouter(translate('translations')(MapViewComponent));


// WEBPACK FOOTER //
// ./src/components/Map/MapView.js